import { Grid } from "@material-ui/core";

import { TemplateGrid } from "../../../components/template-grid/template-grid.component";
import { TemplateName } from "../../../types/templates/template-name";
import { useWorkOrderTemplateOptions } from "../../../pages/work-order/types/work-order-template.hooks";
import { WORK_ORDER_HOOK } from "../../../pages/work-order/types/work-order-template.interface";
import { WORK_ORDER_TEMPLATE } from "../../../types/templates/work-order/work-order-template.enum";

import { BorderedBlock } from "../../common-attributes/components/bordered-block/bordered-block.component";
import { CheckboxField } from "../../forms/fields/checkbox-field/checkbox-field.component";
import { DateField } from "../../forms/fields/date-field/date-field.component";
import { RichTextField } from "../../forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";
import { SelectField } from "../../forms/fields/select-field/select-field.component";
import { StatusSection } from "../../common-attributes/components/status-section/status-section.component";
import { TextField } from "../../forms/fields/text-field/text-field.component";
import { UserSearchField } from "../../forms/fields/user-search-field/user-search-field.component";
import { END_DATE, START_DATE } from "../../new-execution-briefs/constants";

import {
  ADDITIONAL_ASSETS_LOCATION,
  ARE_ADDITIONAL_ASSETS_PROVIDED,
  ASSET_DESCRIPTION,
  ASSET_TYPE,
  COLOUR,
  COPY_DIRECTION,
  DUE_AT,
  FILE_FORMAT_DESCRIPTION,
  IS_BUY_GET,
  IS_CREATIVE_REVIEW_REQUIRED,
  OBJECTIVE_OR_PURPOSE,
  SIZE,
} from "../constants";

import { UserSearchFieldSelection } from "./common/user-search-field-selection/user-search-field-selection.component";
import { IWorkOrderTemplate, pageType } from ".";
import { HiddenHeading } from "../../../pages/pages.styles";

export const WorkOrderDealerAdvertisingTemplate = (props: IWorkOrderTemplate) => {
  const { assetRequestOptions, assetTypeOptions, fileFormatOptions } = useWorkOrderTemplateOptions(
    [WORK_ORDER_HOOK.ASSET_REQUESTS, WORK_ORDER_HOOK.ASSET_TYPES, WORK_ORDER_HOOK.FILE_FORMATS],
    WORK_ORDER_TEMPLATE.DEALER_ADVERTISING
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <HiddenHeading>{props.pageTitle}</HiddenHeading>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={ASSET_DESCRIPTION.TITLE}
            name={ASSET_DESCRIPTION.ID}
            required
            subTitle={TemplateName.WorkOrder.DealerAdvertising}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <DateField
                form={props.form}
                label={START_DATE.TITLE}
                name={START_DATE.ID}
                required
                userPermissions={props.userPermissions}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <DateField
                form={props.form}
                label={END_DATE.TITLE}
                name={END_DATE.ID}
                required
                userPermissions={props.userPermissions}
              />
            </Grid>
          </Grid>
        </BorderedBlock>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={OBJECTIVE_OR_PURPOSE.TITLE}
            name={OBJECTIVE_OR_PURPOSE.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={COPY_DIRECTION.TITLE}
            name={COPY_DIRECTION.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
        <TemplateGrid container spacing={3}>
          <Grid item xs={12} md={6}>
            <BorderedBlock>
              <SelectField
                form={props.form}
                label="Category"
                name="assetRequest"
                options={assetRequestOptions}
                userPermissions={props.userPermissions}
              />
            </BorderedBlock>
          </Grid>
          <Grid item xs={12} md={6}>
            <BorderedBlock>
              <SelectField
                form={props.form}
                label={COLOUR.TITLE}
                name={COLOUR.ID}
                options={[
                  { value: 1, label: "Full colour" },
                  { value: 2, label: "Black and White" },
                ]}
                userPermissions={props.userPermissions}
              />
            </BorderedBlock>
          </Grid>
          <Grid item xs={12} md={6}>
            <BorderedBlock>
              <SelectField
                form={props.form}
                label={ASSET_TYPE.TITLE}
                name={ASSET_TYPE.ID}
                options={assetTypeOptions}
                userPermissions={props.userPermissions}
              />
            </BorderedBlock>
          </Grid>
          <Grid item xs={12} md={6}>
            <BorderedBlock>
              <TextField
                form={props.form}
                label={SIZE.TITLE}
                name={SIZE.ID}
                userPermissions={props.userPermissions}
              />
            </BorderedBlock>
          </Grid>
        </TemplateGrid>
        <BorderedBlock>
          <CheckboxField
            form={props.form}
            label={ARE_ADDITIONAL_ASSETS_PROVIDED.TITLE}
            name={ARE_ADDITIONAL_ASSETS_PROVIDED.ID}
            userPermissions={props.userPermissions}
          >
            <RichTextField
              form={props.form}
              label={ADDITIONAL_ASSETS_LOCATION.TITLE}
              name={ADDITIONAL_ASSETS_LOCATION.ID}
              userPermissions={props.userPermissions}
            />
          </CheckboxField>
        </BorderedBlock>
      </Grid>
      <Grid item xs={12} md={4}>
        <StatusSection
          form={props.form}
          label="Status"
          name="status"
          pageType={pageType}
          userPermissions={props.userPermissions}
        />
        <BorderedBlock>
          <UserSearchField
            form={props.form}
            label="Assign"
            name="contentCreatorsSelection"
            resourceId={props.resourceId}
            resourceType={props.resourceType}
            SelectionComponent={UserSearchFieldSelection}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <DateField
            form={props.form}
            label={DUE_AT.TITLE}
            name={DUE_AT.ID}
            required
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <CheckboxField
            form={props.form}
            label={IS_CREATIVE_REVIEW_REQUIRED.TITLE}
            name={IS_CREATIVE_REVIEW_REQUIRED.ID}
            userPermissions={props.userPermissions}
          />
          <CheckboxField
            form={props.form}
            label={IS_BUY_GET.TITLE}
            name={IS_BUY_GET.ID}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <SelectField
            form={props.form}
            label="File Format"
            name="fileFormat"
            options={fileFormatOptions}
            userPermissions={props.userPermissions}
          />
          <RichTextField
            form={props.form}
            label={FILE_FORMAT_DESCRIPTION.TITLE}
            name={FILE_FORMAT_DESCRIPTION.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
      </Grid>
    </Grid>
  );
};
